import {
  AreaChart,
  BadgeCent,
  Bell,
  Book,
  CandlestickChart,
  Coins,
  Settings,
  CreditCard,
  LayoutDashboard,
  LayoutTemplate,
  PieChart,
  ScatterChart,
  ScrollText,
  User,
  Videotape,
  Globe,
  HandCoins,
} from "lucide-react";

import { Options } from "../redux/sidebar.slice";

export const iconsMaping = (name: string) => {
  switch (name) {
    case "PieChart":
      return PieChart;

    case "Settings":
      return Settings;

    case "LayoutTemplate":
      return LayoutTemplate;

    case "Globe":
      return Globe;

    case "ScatterChart":
      return ScatterChart;

    case "CandlestickChart":
      return CandlestickChart;

    case "ScrollText":
      return ScrollText;

    case "CandlestickChart":
      return CandlestickChart;

    case "Book":
      return Book;

    case "AreaChart":
      return AreaChart;

    case "LayoutDashboard":
      return LayoutDashboard;

    case "Coins":
      return Coins;

    case "CreditCard":
      return CreditCard;

    case "CandlestickChart":
      return CandlestickChart;

    case "User":
      return User;

    case "BadgeCent":
      return BadgeCent;

    case "Bell":
      return Bell;

    case "VideoTape":
      return Videotape;

    case "HandCoins":
      return HandCoins;
  }
};

// export const dashboardOptions = (m: any): Options[] => [
//   {
//     title: m.dashboard(),
//     icon: "LayoutDashboard",
//     variant: "ghost",
//     href: "/dashboard",
//   },
//   {
//     title: m.assets(),
//     icon: "Coins",
//     variant: "ghost",
//     href: "/dashboard/assets",
//   },
//   {
//     title: m.transactions(),
//     icon: "CreditCard",
//     variant: "ghost",
//     href: "/dashboard/transactions",
//   },
//   {
//     title: m.open_orders(),
//     icon: "CandlestickChart",
//     variant: "ghost",
//     href: "/dashboard/open-orders",
//   },
// ];

// export const smartAllocationOptions = (m: any): Options[] => [
//   {
//     title: m.allocation(),
//     icon: "PieChart",
//     variant: "ghost",
//     href: "/smart-allocation",
//   },
//   {
//     title: m.templates(),
//     icon: "LayoutTemplate",
//     variant: "ghost",
//     href: "/smart-allocation/templates",
//   },
//   {
//     title: m.backtest(),
//     icon: "ScatterChart",
//     variant: "ghost",
//     href: "/smart-allocation/back-test",
//   },
//   {
//     title: m.automation(),
//     icon: "CandlestickChart",
//     variant: "ghost",
//     href: "/smart-allocation/automation",
//   },
//   {
//     title: m.logbook(),
//     icon: "ScrollText",
//     variant: "ghost",
//     href: "/smart-allocation/logs",
//   },
// ];

// export const tradeOptions = (m: any): Options[] => [
//   {
//     title: m.trade(),
//     icon: "CandlestickChart",
//     variant: "ghost",
//     href: "/trade",
//   },
//   {
//     title: m.orderbook(),
//     icon: "Book",
//     variant: "ghost",
//     href: "/trade/order-book",
//   },
//   {
//     title: m.open_orders(),
//     icon: "AreaChart",
//     variant: "ghost",
//     href: "/trade/open-orders",
//   },
// ];

// export const settingsOptions = (m: any): Options[] => [
//   {
//     title: m.account(),
//     icon: "User",
//     variant: "ghost",
//     href: "/settings",
//   },
//   {
//     title: m.exchanges(),
//     icon: "BadgeCent",
//     variant: "ghost",
//     href: "/settings/exchanges",
//   },
//   {
//     title: m.billing(),
//     icon: "CreditCard",
//     variant: "ghost",
//     href: "/settings/billing",
//   },
//   {
//     title: m.alerts(),
//     icon: "Bell",
//     variant: "ghost",
//     href: "/settings/alerts",
//   },
//   {
//     title: m.courses(),
//     icon: "VideoTape",
//     variant: "ghost",
//     href: "/settings/courses",
//   },
// ];

// export const assetOptions = (m: any): Options[] => [
//   {
//     title: m.overview(),
//     icon: "LayoutTemplate",
//     variant: "ghost",
//     href: "/asset",
//   },
//   {
//     title: m.asset_info(),
//     icon: "Book",
//     variant: "ghost",
//     href: "/asset/details",
//   },
//   {
//     title: m.orders(),
//     icon: "CreditCard",
//     variant: "ghost",
//     href: "/asset/orders",
//   },
// ];

export const fullMenu = (m: any): Options[] => [
  {
    title: m.dashboard(),
    icon: "LayoutDashboard",
    href: "/dashboard",
    subMenu: [
      {
        title: m.assets(),
        icon: "Coins",
        href: "/dashboard/assets",
      },
      {
        title: m.transactions(),
        icon: "CreditCard",
        href: "/dashboard/transactions",
      },
      {
        title: m.open_orders(),
        icon: "CandlestickChart",
        href: "/dashboard/open-orders",
      },
    ],
  },
  {
    title: m.smart_allocation(),
    icon: "PieChart",
    href: "/smart-allocation",
    subMenu: [
      {
        title: m.templates(),
        icon: "LayoutTemplate",
        href: "/smart-allocation/templates",
      },
      {
        title: m.automation(),
        icon: "CandlestickChart",
        href: "/smart-allocation/automation",
      },
      {
        title: m.logbook(),
        icon: "ScrollText",
        href: "/smart-allocation/logs",
      },
    ],
  },
  {
    title: m.trade(),
    icon: "CandlestickChart",
    href: "/trade",
    subMenu: [
      {
        title: m.orderbook(),
        icon: "Book",
        href: "/trade/order-book",
      },
      {
        title: m.open_orders(),
        icon: "AreaChart",
        href: "/trade/open-orders",
      },
    ],
  },
  {
    title: m.market(),
    icon: "Globe",
    href: "/market",
  },
  {
    title: m.courses(),
    icon: "VideoTape",
    href: "/courses",
  },
  {
    title: m.alerts(),
    icon: "Bell",
    href: "/alerts",
  },
  {
    title: m.settings(),
    icon: "Settings",
    href: "/settings",
    subMenu: [
      {
        title: m.account(),
        icon: "User",
        href: "/settings",
      },
      {
        title: m.exchanges(),
        icon: "BadgeCent",
        href: "/settings/exchanges",
      },
      {
        title: m.billing(),
        icon: "CreditCard",
        href: "/settings/billing",
      },
    ],
  },
  {
    title: "Affiliation",
    icon: "HandCoins",
    href: "/affiliation",
  },
];
